const CastAndCrew = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_943_36776)">
      <path
        d="M13 1.5L2.834 1.5C2.05141 1.5 1.417 2.13441 1.417 2.917L1.417 13.083C1.417 13.8656 2.05141 14.5 2.834 14.5L13 14.5C13.7826 14.5 14.417 13.8656 14.417 13.083L14.417 2.917C14.417 2.13441 13.7826 1.5 13 1.5Z"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 1.55884L4.66699 14.5"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 1.53497L11.333 14.5"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.45312 8L14.3672 8"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.45807 4.66663H4.6663"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.4541 11.3334H4.66683"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 4.66663H14.3864"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 11.33H14.3864"
        stroke="#444444"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_943_36776">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CastAndCrew;
